<template>
    <div class="edit-text-box" contenteditable="true" @keydown="editText" @blur="outFocus" v-html="value"></div>
</template>

<script>
export default {
    props: {
        value: {
            type: String
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        editText (event) {
            let keyCode = event.keyCode;
            if (!this.editable && keyCode !== 8) {
                // 只响应删除事件
                event.preventDefault();
            }
        },
        outFocus (event) {
            this.update(event.target);
        },
        update (target) {
            let newValue = target.innerHTML;
            this.$emit('input', newValue);
        }
    }
};
</script>

<style lang="less">
.edit-text-box {
    padding: 5px;
    outline: none;
    width: 100%;
}
</style>
